const CountdownTimer = () => { return import(/* webpackChunkName: 'countdown-timer' */'./CountdownTimer.vue'); };

export {
    CountdownTimer,
};
